import React, { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import styles from "./Timeline.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarCheck } from "@fortawesome/free-regular-svg-icons";
import Timelinedata from "./Timelinedata";

/* ---------- SINGLE TIMELINE ITEM (UI UNCHANGED) ---------- */
// const TimelineItem = ({ time, event }) => {
//   const { ref, inView } = useInView({ triggerOnce: true});

//   return (
//     <section className={styles.space}>
//       <div className={styles.tagg}>
//         <FontAwesomeIcon icon={faCalendarCheck} className={styles.iconv} />
//       </div>

//       <div
//         ref={ref}
//         className={`${styles.box} ${inView ? styles.inView : ""}`}
//       >
//         <div className={styles.part2}>
//           <h3 className={styles.heading}>
//             <span className={styles.time}>{time} : </span>
//             {event}
//           </h3>
//         </div>
//       </div>

//       <div className={styles.dateWrapper}>
//         <div id={styles["date1"]}>{time}</div>
//       </div>
//     </section>
//   );
// };
const TimelineItem = ({ time, event, side }) => {
  const { ref, inView } = useInView({
    triggerOnce: false,
    threshold: 0.2
  });

  return (
    <section className={`${styles.space} ${styles[side]}`}>
      
      <div className={styles.tagg}>
        <FontAwesomeIcon
          icon={faCalendarCheck}
          className={styles.iconv}
        />
      </div>

      <div
        ref={ref}
        className={`${styles.box} ${inView ? styles.inView : ""}`}
      >
        <div className={styles.part2}>
          <h3 className={styles.heading}>
            <span className={styles.time}>{time} : </span>
            {event}
          </h3>
        </div>
      </div>

      <div className={styles.dateWrapper}>
        <div id={styles["date1"]}>{time}</div>
      </div>

    </section>
  );
};

/* -------------------- MAIN COMPONENT -------------------- */
const Timeline = () => {
  const [redl] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <div className={styles.straps}>
        <p>Timeline</p>
      </div>

      <div className={styles.container_2}>
        <section className={styles.timeline}>
          <div className={styles.line}>
            <div className="redline" style={{ height: redl }}></div>
          </div>

          {Timelinedata.map((item, index) => (
            <TimelineItem
              key={index}
              time={item.time}
              event={item.event}
              side={index % 2 === 0 ? "left" : "right"}
            />
          ))}
        </section>
      </div>
    </div>
  );
};

export default Timeline;
